import * as z from 'zod'
import { decodeToken } from '@comun/token-utils';
import { AppConfigFrontZod } from '@comun/appsConfigs';
import { UsuarioZod } from '@boxmagic/tiposComunes'
import { consolo } from '@base/composables/consolo'
import { MiniID } from '@base/composables/miniid'
import { StringZod } from '@base/composables/zodComunBase'
import { UsuarioAPI } from './cuenta'
import { LlaverosAPI } from '@base/composables/llavero-cliente'

export async function IntegrarElementosFrescos({
  url,
  fetchConfig,
  dataRecibida
}: {
  url: string,
  fetchConfig: RequestInit
  dataRecibida: unknown
}) {
  const fx = 'IntegrarElementosFrescos'
  const timerID = `🗂️ ${MiniID(3)} ${fx} desde ${url}`
  // console.time(timerID)
  // consolo.log('[integracionDeDatos]', timerID, Object.keys(dataRecibida ?? {}), fetchConfig)

  try {
    const parser = z.object({
      app: AppConfigFrontZod.optional(),
      token: StringZod.optional(),
      usuario: UsuarioZod.optional(),
      desconectar: z.literal(true).optional(),
      rotarLlavero: z.literal(true).optional(),
      rotarRegistro: z.literal(true).optional()
    })
    const parseado = parser.safeParse(dataRecibida)
    if (!parseado.success) {
      consolo.error('[integracionDeDatos]', timerID, 'error de parseo', parseado.error)
      consolo.error('[integracionDeDatos]', parseado.error.issues)
      return
    }

    // Integrar la info que esté presente.'
    const resultado = parseado.data

    if (resultado.desconectar) {
      UsuarioAPI.CerrarSesion()
      return
    }
    if (resultado.rotarLlavero) {
      await LlaverosAPI.RotarLlavero()
      await LlaverosAPI.ObtenerLlaveros()
      return
    }
    if (resultado.rotarRegistro) {
      await LlaverosAPI.RotarRegistro()
      await LlaverosAPI.ObtenerLlaveros()
      return
    }

    await Promise.all([
      (async () => {
        if (!resultado.token) return
        consolo.log('[integracionDeDatos]', 'resultado con token, integrando')
        const decodificado = decodeToken(resultado.token)
        // consolo.log('[integracionDeDatos]', 'token decodificado', decodificado)
        if (decodificado.iss === 'boxmagic') {
          consolo.log('[integracionDeDatos]', 'token de go, no se integra')
          return
        }
        await UsuarioAPI.IntegrarToken(resultado.token)
      })(),
      resultado.usuario ? UsuarioAPI.IntegrarUsuario(resultado.usuario) : undefined

    ])
  } catch (error) {
    consolo.error('[integracionDeDatos]', timerID, error)
    // } finally {
    //     console.timeEnd(timerID)
  }
}